import ThankYouPageView from './ThankYouPageView';
export default ThankYouPageView;
